export const VERSION = '0.4.2'
